import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingTemplateGrouping } from '../interfaces/link-setting-template-grouping.interface';

@Injectable({
  providedIn: 'root'
})
export class SettingTemplateGroupingService {

  readonly url: string = 'SettingTemplateGrouping';

	constructor(private http: HttpClient) {}

  public getAllLinkSettingGroupings(): Observable<SettingTemplateGrouping[]> {
		return this.http.get<SettingTemplateGrouping[]>(this.url);
	}

  public createLinkSettingGroup(createObject: SettingTemplateGrouping): Observable<boolean> {
    return this.http.post<boolean>(this.url, createObject)
  }

  public deleteLinkSettingGroup(id: number): Observable<boolean> {
    return this.http.delete<boolean>(this.url + '/' + id)
  }

  public updateSettingTemplateGroupIndex(settingTemplate: SettingTemplateGrouping[]): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/' + 'BatchUpdateSettingTemplateGrouping', settingTemplate)
  }

  public updateSingleSettingTemplateGrouping(updateObject: SettingTemplateGrouping): Observable<boolean> {
    return this.http.patch<boolean>(this.url, updateObject);
  }
}
